import get from 'lodash/get';
import { v4 as uuid } from 'uuid';
import { RxSocketUrls } from '@Constants/CommonConstants';
import SocketBroker from '@Services/SocketBroker';
import RxSocket from '@Services/RxSocket';

// eslint-disable-next-line import/prefer-default-export
export const retrievePatentFamilyMembers = ({
  resultName,
  semanticSearchIncluded,
  semanticResultName,
  databaseId,
  context,
  documentIndex,
  hitSetKey,
  sort,
  order,
  firstSubItem,
  lastSubItem,
}) => {
  const requestId = uuid();
  const { ResultsInfo } = RxSocketUrls.ChannelsUrls;
  const params = {
    requestId,
    resultName,
    semanticSearchIncluded,
    semanticResultName,
    hitSetKey,
    databaseId,
    context,
    sort,
    order,
    firstItem: documentIndex,
    lastItem: documentIndex,
    firstSubItem,
    lastSubItem,
  };

  return new Promise((resolve, reject) => {
    const unsubscribe = SocketBroker.observe(ResultsInfo, (response) => {
      if (get(response, 'info.query.requestId') !== requestId) return;

      const entities = get(response, 'payload.entities');

      if (!entities) {
        const error = new Error('Error while retrieving patent family members - no entities in response');
        reject(error);
        return;
      }

      const formattedEntities = Object.keys(entities).map((index) => ({
        ...entities[index],
        index,
      }));

      resolve(formattedEntities);
      unsubscribe();
    });

    RxSocket.send(RxSocketUrls.ResultsUrl, params);
  });
};
